import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
  AuthEffects,
  authenticateReducer,
  STORE_NAME,
  MfaEffects,
  SsoEffects,
  InvitationEffects,
} from '@rx-applications/shared/auth/data-access';

@NgModule({
  imports: [
    StoreModule.forFeature(STORE_NAME, authenticateReducer),
    EffectsModule.forFeature([AuthEffects, MfaEffects, SsoEffects, InvitationEffects]),
  ],
})
export class AuthStateModule {}
